module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAdVBMVEUAAAD/QADYJxTdIiLfICDhHh7jKxzeIRnfKBjjIhzfJhrgJRnhIxnhJBvgJBrhIxniJRvhJBrhJBrhJBrhJRniJBvhJBrhIxrhJRrhJBrhJBnhIxrgJBrhJBvhJBrhJBrhJBrhJBrhJBrhJBrhJBrhJBrhJBogLI69AAAAJnRSTlMABA0PEBESHyAlKCkzVWJmaKqwsbW2wcLDxdLY2d3j5efp7vD4/fThdzEAAACrSURBVEjH7ZZJEoIwEEUbBTGgiCMoxAGw739ED9BDKlQKN3nLrnqV/ov8BCCyKDeUaXgFNSQlk5AVcWdZ2UnIyowsViJoFoDyQCl1pWdi9LpSHSmVrszIUjOn1LrSMVk6XTF7igme5cwsdtKVK6NcHIul5K6kEDxLVP6hbBylRGfJx1FKdLbGr7WDpzJC8fZVzAsbP2V64n3l81jkiPjYZgFrvFWMNv4LFuUHORRCdoasTuQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/discountTrends/Pad@2x.png
// module id = n1WQ
// module chunks = 70